export const linkTree = [
  {
    id: 0,
    name: "linkedin",
    link: "https://www.linkedin.com/in/batuhanmunger/",
  },
  { id: 1, name: "github", link: "https://github.com/dexdere" },
  {
    id: 2,
    name: "hackerrank",
    link: "https://www.hackerrank.com/batuhanmunger",
  },
  {
    id: 3,
    name: "wordpress course",
    link: "https://www.udemy.com/course/wordpressmidedin/",
  },
  { id: 4, name: "projects", link: "#/projects", target: "_self" },
  { id: 5, name: "cv", link: "/Batuhan-Munger-cv.pdf", target: "_self" },
];
